import {$qsAll} from '../../../@shared/ts/dom';
import {type IDictionary} from '../../../@type/dictionary';

/**
 * Clears a input of a given query selector
 */
export function clearInput(selector: string): void {
	for (const $element of $qsAll<HTMLInputElement>(selector)) {
		$element.value = '';
	}
}

/**
 * Generates a dropdown html select list from an array of strings as the select data
 */
export function renderDropDownList(data: IDictionary, defaultOption = ''): string {
	if (!data) {
		data = {};
	}

	const list: string[] = [];
	for (const key in data) {
		if (!Object.prototype.hasOwnProperty.call(data, key)) {
			continue;
		}

		const value = data[key] ?? '';
		list.push(`<option value="${key}"> ${value} </option>`);
	}

	if (defaultOption) {
		return `<option hidden disabled selected value="">${defaultOption}</option>${list.join('')}`;
	}

	return list.join('');
}

/**
 * Selects a HTML select list value or if the value does not exist defaults to the default option.
 */
export function selectDropdown($select: HTMLSelectElement | null, value: string): void {
	if (!$select) {
		return;
	}

	$select.value = value;
}
